enum ServiceIntentionTypes {
  START = "start",
  END = "end"
}

export default ServiceIntentionTypes;
